import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Users, Bot, MessageSquare, LayoutGrid, ShieldCheck, Zap } from "lucide-react";

const features = [
  {
    icon: Users,
    title: "Multiatendimento",
    description: "Um único número para toda a equipe, dividido por departamentos (Comercial, Suporte, Financeiro).",
  },
  {
    icon: Bot,
    title: "IA Generativa",
    description: "Agentes autônomos que qualificam leads e agendam reuniões 24h por dia.",
  },
  {
    icon: MessageSquare,
    title: "Omnichannel",
    description: "Gestão unificada de WhatsApp API, Instagram, Facebook, Telegram e E-mail.",
  },
  {
    icon: LayoutGrid,
    title: "Gestão Visual",
    description: "Painel Kanban para controle total do funil de atendimento.",
  },
  {
    icon: ShieldCheck,
    title: "API Oficial do WhatsApp",
    description: "Somos parceiros oficiais! Garanta total estabilidade, segurança de dados e zero risco de bloqueio para o número principal da sua empresa.",
  },
  {
    icon: Zap,
    title: "Chatbot de Alta Conversão",
    description: "Responda no automático. Empresas que atendem instantaneamente saem na frente da concorrência e aumentam suas chances de fechamento em até 80%.",
  },
];

const ARPChatSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="solucoes"
      className="py-20 lg:py-32 bg-brand-charcoal relative"
      data-testid="arpchat-section"
      ref={ref}
    >
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-ruby to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-2 bg-brand-ruby/10 text-brand-ruby text-sm font-bold tracking-wider uppercase rounded-full mb-4">
            ARPChat
          </span>
          <h2 className="font-montserrat font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-4">
            Transforme seu WhatsApp em uma{" "}
            <span className="text-brand-ruby">Máquina de Vendas</span>
          </h2>
          <p className="text-white/60 text-base sm:text-lg">
            O coração do nosso ecossistema de comunicação empresarial
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              className="card-hover group p-6 lg:p-8 bg-brand-gray/50 border border-white/10 rounded-2xl"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`arpchat-feature-${index}`}
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0 w-14 h-14 bg-brand-ruby rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                  <feature.icon className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-white mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ARPChatSection;
